module.exports = __webpack_public_path__ + "static/screenshot-editorial-d1b387b32d46407d2b0110a3bc80a456.png";